export default {
  root: {
    padding: '6px 8px',
  },
  primary: {
    fontSize: '24px',
    fontWeight: 'bold',
  }
};
